import { Route } from '@angular/router';

export default [
  {
    path: '',
    loadComponent: () =>
      import('./layout-auth/layout-auth.component').then(
        (mod) => mod.LayoutAuthComponent
      ),
    children: [
      {
        path: '',
        redirectTo: 'iniciar',
        pathMatch: 'full',
      },
      {
        path: 'iniciar',
        title: 'Te Llevo-Inicio',
        loadComponent: () =>
          import('./components/login/login.component').then(
            (mod) => mod.LoginComponent
          ),
      },
    ],
  },
] as Route[];
